import { render, staticRenderFns } from "./AlarmManagement.vue?vue&type=template&id=54b7bbb0&"
import script from "./AlarmManagement.vue?vue&type=script&lang=js&"
export * from "./AlarmManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports